import { FunctionComponent } from 'react'

import styled, { css, useTheme } from 'styled-components'

import { mobileCSS } from '@measures/responsive'
import SvgIcon from '@components/SvgIcon'

import { WidgetButtonProps } from '../types'

const StyledWidgetButton = styled.button`
  ${({
    theme: {
      colors: { fillDefault, textDefault, strokeDefault, fillWeak },
      spacing: { spacing16 },
      typography: {
        subheads: {
          medium1: { bundledCSS: medium1HeadingCSS },
        },
      },
    },
  }) => css`
    ${medium1HeadingCSS};
    background: ${fillDefault};
    color: ${textDefault};
    border: 1px solid ${strokeDefault};
    max-width: 100%;
    border-radius: 4px;
    text-align: left;
    padding: ${spacing16};
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (hover: hover) {
      &:hover {
        background: ${fillWeak};
      }
    }

    &:disabled {
      pointer-events: none;
    }

    ${mobileCSS(css`
      width: 100%;
    `)}
  `}
`

const StyledSvgIcon = styled(SvgIcon)`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    min-width: 24px;
    min-height: 24px;
    margin-left: ${spacing8};
  `}
`

const WidgetButton: FunctionComponent<WidgetButtonProps> = ({
  children,
  onClick,
  disabled,
  iconSize = 24,
  className,
}) => {
  const theme = useTheme()

  return (
    <StyledWidgetButton
      onClick={() => onClick && onClick()}
      disabled={disabled}
      className={className}
    >
      {children}
      <StyledSvgIcon
        iconName="stars"
        size={iconSize}
        color={theme.colors.fillBrand}
      />
    </StyledWidgetButton>
  )
}

export default WidgetButton
